import { getModalPortal } from "../../../../../helpers/modal-helper";
import { TActionObject } from "../../../../../types/modal-types";
import { AnimatePresence, m as motion } from "motion/react";
import styles from "./mobile-menu-modal.module.less";
import * as Dialog from "@radix-ui/react-dialog";
import { t } from "i18next";

type TMobilMenuModalProps = {
  children?: React.ReactNode;
  isOpen: boolean;
  portalContainer?: HTMLElement | null;
  close?: TActionObject;
  anchor?: "bottom" | "right";
};

export const MobileMenuModal = ({
  children,
  isOpen,
  portalContainer,
  close,
  anchor = "bottom",
}: TMobilMenuModalProps) => {
  const onClickOverlay = typeof close?.function === "function" ? close.function : undefined;
  const portal = portalContainer ? portalContainer : getModalPortal();

  const duration = 0.265;

  const modalAnimation = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: duration, type: "tween", ease: "easeInOut" },
  };

  const contentAnimationY = {
    initial: { y: "100%" },
    animate: { y: 0 },
    exit: { y: "100%" },
    transition: { duration: duration, type: "tween", ease: "easeInOut" },
  };

  const contentAnimationX = {
    initial: { x: "100%" },
    animate: { x: 0 },
    exit: { x: "100%" },
    transition: { duration: duration, type: "tween", ease: "easeInOut" },
  };

  const animation = anchor === "bottom" ? contentAnimationY : contentAnimationX;

  return (
    <AnimatePresence key={anchor}>
      {isOpen && (
        <Dialog.Root open={isOpen} modal={true}>
          <Dialog.Portal container={portal}>
            <motion.div {...modalAnimation}>
              <Dialog.Overlay className={[styles.modalOverlay].join(" ")} />
            </motion.div>
            <Dialog.Content onEscapeKeyDown={onClickOverlay} className={[styles.content, styles[anchor]].join(" ")}>
              <motion.div {...animation}>
                <div className={styles.innerContent}>{children}</div>
              </motion.div>
            </Dialog.Content>
          </Dialog.Portal>
        </Dialog.Root>
      )}
    </AnimatePresence>
  );
};

export default MobileMenuModal;
